<div class="action-arrow__content">
	<a class="action-icon action-icon-active" (click)="onDeleteDataMessageType()">
		<i class="fas fa-trash active"></i>
	</a>
	<a class="action-icon action-icon-active" (click)="onEditDataMessageType()">
		<i class="fas fa-edit active"></i>
	</a>
</div>
